let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aQi9w")).then(() => parcelRequire('9ZasX'));